var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote-component tva-row"},[_c('div',{class:['quote', 'tva-col-md-offset-2 tva-col-md-8 tva-col-sm-offset-2 tva-col-sm-8 tva-col-xs-12', {'active': _vm.active}]},[_c('span',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }